/* ============================================================
   tc60-v5 · THE PEOPLE — "The Lineup" (Thailand)

   Ported from the SG page 2026-08-14. TH has named five staff (Muffin,
   Leo, Tony, Frank, Nam), each with a real photo, a real store (Sonos
   Store by TC Acoustic) and a product pick. Google reviews landed
   2026-08-14 for four of the five (Muffin, Tony, Frank, Nam) — Leo's is
   still pending, and no `role` credential has come through for anyone
   yet. tc60-v5.js's inlineCopy()/renderBand()/panel-photo rendering all
   treat `photo`, `review` and `pick` as optional (see the SG source
   file's guards), so a name-only panel renders "Photo TBC" + "Review
   coming soon." instead of breaking. Fill in cred/Leo's review as
   they're confirmed — no other code change needed.
   ============================================================ */
(function () {
  'use strict';

  var lineup = document.querySelector('[data-lineup]');
  if (!lineup) return;

  var CDN = 'https://cdn.shopify.com/s/files/1/0299/5830/7976/files/';
  /* resolved `asset_url` for Shanny's pick photo — see the data-px8-photo
     comment beside [data-lineup] in page.tc60.liquid for why this can't
     just be another CDN filename like the rest of pick.img. */
  var PX8_PHOTO = lineup.getAttribute('data-px8-photo') || '';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STARS = '★★★★★';
  /* The curly quotes around every review are REAL CHARACTERS in the text,
     not `.lq-text::before/::after` content as they were until 2026-08-03.
     Two reasons: generated content does not come along when a reader
     selects and copies the quote, and the pseudo-elements were needed for
     the hanging rule that now marks the band's quote as a quote — see
     tc60-v6.css §6. The v5 rules that generated them are overridden to
     `content: none` there; if this line is reverted, revert that too or
     every review shows two of each mark. */

  /* ----------------------------------------------------------
     THE CAST — Thailand.

     Muffin, Leo, Tony, Frank and Nam are the five named staff, each with a
     real photo (2026-08-14) and a real store (2026-08-14: Sonos Store by
     TC Acoustic). Still placeholder: `role` (every one below is the same
     "Sales Executive" text tc60-v5.js falls back to when it isn't known
     yet) for all five, and credential for all five. Google reviews landed
     2026-08-14 for Muffin, Tony, Frank and Nam (attributed to the Google
     reviewer, no date given); Leo's has no `review` field yet, so only
     his panel and band still render "Review coming soon." per the
     optional-field guards already in tc60-v5.js/tc60-v7.css.

     PICKS, added 2026-08-14 — each is the product + one-line reason Bryan
     gave for that person, trimmed of its surrounding quote marks and
     emoji to match the plain-text `why` copy on every other pick on this
     page (SG's five have none either). Photos are real lifestyle shots,
     not studio cutouts, same standard as SG's Arc Ultra/Era 300/Major V
     picks:
       · Muffin's Play and Nam's Era 100 reuse the same CDN Files this
         page's own #promo bestseller slider already uses for those two
         products (`Sonos_play_1.png`, `era_100.png` — see
         templates/page.tc60.liquid and snippets/sonos-pathfinder-v8.liquid).
       · Frank's Beam (Gen 2) and Tony's Sub 4 are CDN Files already used
         elsewhere in this theme (snippets/sonos-pathfinder-v8.liquid's
         IMGS map) but not yet on this page.
       · Leo's Five has no existing CDN File in this library, so `img` is
         the absolute URL of a real photo (no burned-in marketing text —
         several of the product page's other images are marketing cards
         and were rejected for exactly that) straight from the live
         Sonos Five product page — pickShot() (below) already handles an
         absolute URL for exactly this case, same as SG's Reuben/Zi Hao
         picks (tc60-v5.js in the SG repo). Flag if this one should be
         re-uploaded as a proper Files asset instead of staying an
         absolute product-page URL. */
  var CAST = [
    {
      name: 'Muffin', store: 'Sonos Store by TC Acoustic', role: 'Sales Executive', photo: 'Muffin_1.png',
      review: {
        text: 'The absolute best service! Buying remotely was a total breeze thanks to Muffin. He was super responsive at all hours and gave expert advice with solid pricing. Even post-purchase, when I decided to make a change to my order, he didn&rsquo;t miss a beat-attentive, flexible, and so easygoing about it. Service like Muffin&rsquo;s is truly rare to find. Couldn&rsquo;t recommend him more!',
        by: 'Itai Frieberger'
      },
      pick: {
        product: 'Play', img: 'Sonos_play_1.png',
        why: 'Compact and easy to move around, but still has a wide, full sound — my grab-and-go speaker.'
      }
    },
    {
      name: 'Leo', store: 'Sonos Store by TC Acoustic', role: 'Sales Executive', photo: 'leo.jpg',
      pick: {
        product: 'Five',
        img: 'https://cdn.shopify.com/s/files/1/0299/5830/7976/products/Sonos-Five-Sonos-1610170227.jpg?v=1702027288',
        why: 'Powerful, deep bass — clean and detailed even at high volume.'
      }
    },
    {
      name: 'Tony', store: 'Sonos Store by TC Acoustic', role: 'Sales Executive', photo: 'tony.jpg',
      review: {
        text: 'I have used this company for years, originally in Singapore. The Thai branch continues a tradition of Excellence. This time I needed them for after sale help: K. Tony and K. Thip stepped up above and beyond what was hoped for, with quick and thorough questions and a prompt resolution. Well done!',
        by: 'Matteo Caraccia'
      },
      pick: {
        product: 'Sub 4', img: 'sub_4_b6b7660b-7728-4182-a0a8-930127556430.png',
        why: 'Flexible and easy wireless setup — put it anywhere and it brings serious rumble to movies and music.'
      }
    },
    {
      name: 'Frank', store: 'Sonos Store by TC Acoustic', role: 'Sales Executive', photo: 'frank.jpg',
      review: {
        text: 'I stopped by the Sonos flagship store. Frank was very helpful and gave great recommendations. The products are high quality, the store is beautiful, and the staff are good-looking and have lovely personalities. Highly recommend!',
        by: 'Mahaporn Mungkala'
      },
      pick: {
        product: 'Beam (Gen 2)', img: 'Bravo_Black_Edited_2.png',
        why: 'Great for music, and it makes movies way more fun — big sound from a compact soundbar.'
      }
    },
    {
      name: 'Nam', store: 'Sonos Store by TC Acoustic', role: 'Sales Executive', photo: 'Nam_1.png',
      review: {
        text: 'First time trying their headphones and I was very impressed with how well the noise cancellation works! The staff were very friendly, helpful, and welcoming. Nam gave great advice and did not make me feel pressured to make an immediate decision. They do a very good job of making you feel comfortable and supported rather than pushing you to buy. I would definitely come back to ask for more details. Their speakers are now at the top of my list for my living room - especially the Era 300.',
        by: 'Pornthip Powanna'
      },
      pick: {
        product: 'Era 100', img: 'era_100.png',
        why: "It's small, but the sound really fills the room — an easy first Sonos for most people."
      }
    }
  ];

  /* ----------------------------------------------------------
     BUILD THE ROW
     ---------------------------------------------------------- */
  var DEAL_STEP = 60;   /* ms between panels dealing in */

  /* Mobile carries the band's copy inside each card (the band is display:none
     under 760). Built for every panel and hidden by CSS at the other tier
     rather than branched on width here — a resize must not need a rebuild. */
  /* The product shot beside the pick.

     ALL SEVEN ARE NOW LIFESTYLE PHOTOGRAPHS (Bryan, 2026-08-03: "can it all
     be lifestyle photos instead?"). That single change deleted a whole class
     of problem. The old set was five transparent cut-outs plus two room
     shots, which needed two `object-fit` rules, a LIGHT well (because a
     transparent black soundbar is invisible on ink) and 9px of padding to
     keep cut-outs off the edges — and it still could not make the Arc read.
     Seven photographs want exactly one rule: `cover`, no padding, no ground,
     because the photograph IS the ground. `scene` is gone from the CAST.

     Two fields carry what a photograph needs and a cut-out did not:

     · `imgq` — a Shopify image query override. Three of the seven are B&W
       marketing cards with a headline burned into the bottom of the frame
       (Zeppelin "Form Meets Function", Px7 S3 and Pi8 "Active Noise
       Cancellation"). `crop=top` with a shortened height removes the text
       band. THE TRAP: Shopify silently DROPS `crop` if `width` exceeds the
       source width, and these three sources are only 1000px — asking for
       width=1600 returns the full uncropped square with the text still in
       it, HTTP 200 and all. Keep these at width=500.
     · `pos` — object-position. A cut-out centred itself; a room shot has a
       subject somewhere specific in the frame, and a centre crop of the Px7
       photograph lands on the model's cheek rather than the headphones. */
  function pickShot(p) {
    if (!p.pick.img) return '';
    /* PX8_PHOTO is already a full, resolved `asset_url` (its own querystring
       and all) rather than a bare CDN filename — prefixing CDN or appending
       imgq onto it would produce a broken URL, so absolute URLs pass
       through untouched instead of going through the usual CDN+imgq build. */
    var abs = /^(https?:)?\/\//.test(p.pick.img);
    var src = abs ? p.pick.img : CDN + p.pick.img + (p.pick.imgq || '?width=500');
    return '<span class="lpick-shot">' +
      '<img src="' + src +
        '" alt="' + p.pick.product + '" loading="lazy"' +
        (p.pick.pos ? ' style="object-position:' + p.pick.pos + '"' : '') + '>' +
      '</span>';
  }

  function pickBlock(p) {
    if (!p.pick) return '';
    return '' +
      '<p class="lpick-lbl">' + p.name + '’s pick</p>' +
      '<div class="lpick-row">' +
        pickShot(p) +
        '<div class="lpick-copy">' +
          '<p class="lpick-prod">' + p.pick.product + '</p>' +
          '<p class="lpick-why">' + p.pick.why + '</p>' +
          /* was a button pressing a `.bundle-chip` — the calculator it
             pressed is gone (2026-08-05, replaced by the #promo product
             slider + paperform embed), so this just links to the offers
             section instead of wiring to a control that no longer exists. */
          '<a class="lpick-go" href="#promo">' +
            'See it in TC60 Offers <span class="arrow">→</span>' +
          '</a>' +
        '</div>' +
      '</div>';
  }

  /* READ MORE, added 2026-08-05 -- the real reviews run much longer than
     the placeholders they replaced (Reuben's and Zi Hao's both run six-
     plus sentences), and a fixed-height panel/band can't just grow to fit
     whichever one is open without the row jumping around under the
     visitor's mouse. `.lq-clamp` (tc60-v7.css) line-clamps to a few lines;
     this toggle is a `role="button"` SPAN, not a real `<button>` -- `.lp`
     (the whole panel) already IS a button, and a nested button silently
     corrupts that parse. wireReadMore() only reveals the toggle when the
     text actually overflows its clamp, so a short review doesn't grow a
     "Read more" that has nothing to show. */
  function moreToggle() {
    return '<span class="lq-more" role="button" tabindex="0" hidden>Read more</span>';
  }

  function wireReadMore(root) {
    var q = root && root.querySelector('.lq-text.lq-clamp');
    var btn = root && root.querySelector('.lq-more');
    if (!q || !btn) return;
    q.classList.remove('is-expanded');
    btn.textContent = 'Read more';
    btn.hidden = true;
    requestAnimationFrame(function () {
      if (q.scrollHeight - q.clientHeight > 2) btn.hidden = false;
    });
  }

  /* Country ports (MY/HK/TH) name staff before their Google reviews and
     product picks are ready \u2014 `review`/`pick` are optional on CAST entries
     so a panel can go live as "name only" rather than block the section on
     content that isn't fact-checked yet. See tc60-v7.css \u00A725/26. */
  function inlineCopy(p) {
    if (!p.review) {
      return '<div class="lp-inline"><p class="lq-text lq-pending">Review coming soon.</p>' +
        (p.pick ? '<div class="lpick">' + pickBlock(p) + '</div>' : '') +
        '</div>';
    }
    return '' +
      '<div class="lp-inline">' +
        '<p class="lq-text lq-clamp">\u201C' + p.review.text + '\u201D</p>' +
        moreToggle() +
        '<div class="lq-by">' +
          '<span class="lq-stars" aria-hidden="true">' + STARS + '</span>' +
          '<cite class="lq-cite">' + p.review.by + '</cite>' +
        '</div>' +
        (p.pick ? '<div class="lpick">' + pickBlock(p) + '</div>' : '') +
      '</div>';
  }

  var panels = [];

  CAST.forEach(function (p, i) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'lp';
    b.setAttribute('aria-expanded', 'false');
    /* The panel names the person, not "panel 4 of 7" — a screen reader
       user should hear who they are about to open. */
    b.setAttribute('aria-label', p.name + ' — ' + p.role + ', ' + p.store);
    if (i > 0 && CAST[i - 1].store !== p.store) b.dataset.clusterStart = 'true';
    if (!reduce) b.style.transitionDelay = (i * DEAL_STEP) + 'ms';

    b.innerHTML = '' +
      (p.photo ?
        '<img src="' + CDN + p.photo + '?width=900" alt="" loading="lazy"' +
          (p.pos ? ' style="object-position:' + p.pos + '"' : '') + '>' +
        (p.photoTBC ? '<span class="lp-tbc">Photo TBC</span>' : '')
      : '<span class="lp-photo-placeholder" aria-hidden="true"></span><span class="lp-tbc">Photo TBC</span>') +
      '<span class="lp-id">' +
        /* the orange `.lp-cred` award/nominee liner (EXSA Excellence
           Award, THX Certified, etc.) was removed on request 2026-08-13.
           `cred`/`credMark` stay on CAST below since they're still real,
           fact-checked data — just no longer rendered here. */
        '<span class="lp-nm">' + p.name + '</span>' +
        /* The separator lives inside .lp-role with a hard space on each side.
           A plain " · " leading the span collapsed at the inline-block
           boundary and rendered "THE ADELPHI· SALES CONSULTANT". "Sales
           Executive" itself stopped rendering on request 2026-08-13 — `role`
           stays on CAST below (Zoe's distinct title still needs it) but the
           generic "Sales Executive" tag no longer shows. */
        '<span class="lp-meta">' + p.store +
          (p.role !== 'Sales Executive' ? '<span class="lp-role">&nbsp;·&nbsp;' + p.role + '</span>' : '') +
        '</span>' +
        inlineCopy(p) +
      '</span>';

    lineup.appendChild(b);
    panels.push(b);
  });

  /* SG's 5-across row is full-bleed by design, but a country port whose
     cast hasn't reached five yet (MY's 2, HK's TBC) doesn't have enough
     people to fill that same edge-to-edge width without
     each panel stretching into a wide, flattened banner instead of a
     portrait. `.lineup--compact` (tc60-v7.css §27) caps panel width
     instead of letting flex-grow fill the row, so a short cast reads as a
     shorter row rather than a stretched one. Threshold is CAST.length, not
     a per-country flag, so a page just grows out of compact mode on its
     own once its real cast reaches five. */
  if (CAST.length && CAST.length < 5) lineup.classList.add('lineup--compact');

  /* ----------------------------------------------------------
     THE BAND — review left, pick right, swapping with the selection.
     ---------------------------------------------------------- */
  var band     = document.querySelector('[data-band]');
  var bandQ    = band && band.querySelector('[data-band-quote]');
  var bandPick = band && band.querySelector('[data-band-pick]');

  var CHAR_STAGGER = 18;   /* ms; the reference used 6 for a long quote */

  /* Per-character rise, from the ScrollReelTestimonials reference. Only the
     product name gets it — see the note in tc60-v5.css. Words are wrapped
     so a long product name still breaks between words, not mid-word. */
  function chars(text) {
    var out = '', idx = 0;
    text.split(' ').forEach(function (word, wi, all) {
      out += '<span style="display:inline-block;white-space:nowrap">';
      Array.prototype.forEach.call(word, function (ch) {
        out += '<span class="lch" style="animation-delay:' + (idx * CHAR_STAGGER) + 'ms">' + ch + '</span>';
        idx++;
      });
      out += '</span>';
      if (wi < all.length - 1) { out += ' '; idx++; }
    });
    return out;
  }

  function renderBand(p) {
    if (!bandQ || !bandPick) return;
    if (!p.review) {
      bandQ.innerHTML = '<p class="lq-text lq-pending">Review coming soon.</p>';
    } else {
      bandQ.innerHTML = '' +
        '<p class="lq-text lq-clamp">\u201C' + p.review.text + '\u201D</p>' +
        moreToggle() +
        '<div class="lq-by">' +
          '<span class="lq-stars" aria-hidden="true">' + STARS + '</span>' +
          '<cite class="lq-cite">' + p.review.by + '</cite>' +
        '</div>';
      wireReadMore(bandQ);
    }
    /* Same block as the mobile card, then the product name is swapped for
       its per-character version. Built once and patched rather than
       duplicated, so the desktop band and the mobile card cannot drift. */
    bandPick.innerHTML = p.pick ? pickBlock(p) : '';
    if (p.pick && !reduce) {
      var prod = bandPick.querySelector('.lpick-prod');
      if (prod) prod.innerHTML = chars(p.pick.product);
    }
  }

  var SWAP_MS = 340;   /* matches .lband.is-swapping's transition */
  var swapTimer = null;
  var openIdx = -1;

  function open(i, focus) {
    if (i === openIdx || !panels[i]) return;
    openIdx = i;

    panels.forEach(function (el, n) {
      var on = n === i;
      el.classList.toggle('is-open', on);
      el.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
    lineup.classList.add('has-open');
    if (focus) panels[i].focus();
    /* mobile's inline copy was hidden (0 height) while its panel was closed,
       so its own overflow check ran against nothing — redo it now that the
       panel is visible. */
    wireReadMore(panels[i]);

    if (!band) return;
    if (reduce) { renderBand(CAST[i]); return; }

    /* Old block out, new block in — never both on screen at once, which is
       the one thing the reference component gets right and most crossfades
       get wrong. */
    band.classList.add('is-swapping');
    clearTimeout(swapTimer);
    swapTimer = setTimeout(function () {
      renderBand(CAST[i]);
      band.classList.remove('is-swapping');
    }, SWAP_MS);
  }

  panels.forEach(function (el, i) {
    el.addEventListener('click', function () { open(i); });
  });

  /* Arrow keys walk the row; Home/End jump to the ends. Panels are real
     buttons, so Tab already works and this is navigation on top of it. */
  lineup.addEventListener('keydown', function (e) {
    var k = e.key, next = null;
    if (k === 'ArrowRight') next = Math.min(openIdx + 1, panels.length - 1);
    else if (k === 'ArrowLeft') next = Math.max(openIdx - 1, 0);
    else if (k === 'Home') next = 0;
    else if (k === 'End') next = panels.length - 1;
    if (next === null) return;
    e.preventDefault();
    open(next, true);
  });

  /* ----------------------------------------------------------
     READ MORE — toggles the clamp on whichever quote the click landed in.
     Delegated once at the document rather than per-panel, since panels are
     rebuilt/reopened repeatedly and a `.lq-more` is recreated every render.
     ---------------------------------------------------------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.lq-more');
    if (!btn) return;
    var q = btn.previousElementSibling;
    if (!q || !q.classList.contains('lq-text')) return;
    var expanded = q.classList.toggle('is-expanded');
    btn.textContent = expanded ? 'Show less' : 'Read more';
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ') return;
    if (!e.target.classList || !e.target.classList.contains('lq-more')) return;
    e.preventDefault();
    e.target.click();
  });

  /* ----------------------------------------------------------
     DEAL-IN, then hand the transition back to flex-grow.

     The inline transition-delay that staggers the deal would also delay
     every later open, so it is stripped once the deal has finished.
     ---------------------------------------------------------- */
  var dealt = false;
  function deal() {
    if (dealt) return;
    dealt = true;
    lineup.classList.add('is-dealt');
    var settle = panels.length * DEAL_STEP + 600;
    setTimeout(function () {
      panels.forEach(function (el) { el.style.transitionDelay = ''; });
    }, reduce ? 0 : settle);
  }

  if (reduce || !('IntersectionObserver' in window)) {
    deal();
  } else {
    new IntersectionObserver(function (es, io) {
      if (es[0].isIntersecting) { deal(); io.disconnect(); }
    }, { rootMargin: '0px 0px -12% 0px' }).observe(lineup);
    /* Same safety net as tc60.js's reveal: never leave the row invisible. */
    setTimeout(deal, 3000);
  }

  /* Reuben opens first — he is now the first panel, and an empty band
     under a row of closed panels reads as a loading state. */
  open(0);
})();
